export default __webpack_public_path__ + "static/media/10.59970df1.png";